/* !
 * jQuery index v1.0.0
 * Copyright 2018, Connecty Inc.
 */
(function($, MIKI){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	let $url = MIKI.va.pathname;

	// ＜共通＞JSON取得 ---------------------------------------------------
	// お気に入りリスト描画用
	const getJSONgetFavoList = (_param) => {
		return $.getJSON(`/ajax/product_list.json?${_param}`);
	};
	// <商品検索>ブランドリスト取得用
	const getJSONgetBrandList = () => {
		return $.getJSON('/ajax/product/brand_list.json');
	};
	// <商品検索>ブランド内カテゴリリスト取得用
	const getJSONgetCategoryList = (_brand) => {
		return $.getJSON(`/ajax/product/${_brand}/brand_category_list.json`);
	};
	// <カテゴリーページ>ブランドごとの商品を取得
	const getJSONgetBrandProd = (_brandKey) => {
		return $.getJSON(`/ajax/product/brand/${_brandKey}.json`);
	};
	// <商品詳細>おすすめリスト取得用
	const getJSONgetrecommendList = (_param) => {
		return $.getJSON(`/ajax/product/recommend.json?${_param}`);
	};
	// <商品詳細>カラー単位(8桁のコード単位)商品情報取得用
	const getJSONgetColorDetail = (_prodCode) => {
		return $.getJSON(`/ajax/product/product/${_prodCode}.json`);
	};
	// <商品詳細>カラー・サイズ(7桁のコード単位)全商品情報取得用
	const getJSONgetAllColorSize = (_prodCode) => {
		return $.getJSON(`/ajax/product_list.json?p_code_7=${_prodCode}`);
	};

	// ＜共通＞----------------------------------------------------
	// ＜共通＞お気に入り商品にアイコン点灯
	const favIcon = () => {
		$('.mod-prodPanel').each(function(){
			let $this = $(this);
			let thisProdCode = $(this).find('.rt_cf_p_code_8').attr('data-p_code_8');
			let flgFavo = checkFavo(thisProdCode);
			if (flgFavo) {
				$this.find('.mod-prodPanel-favorite').addClass(a);
			} else {
				$this.find('.mod-prodPanel-favorite').removeClass(a);
			}
		});
	};

	// ＜共通＞お気に入りに追加,削除
	$(document).on('click',
		'.prod-modal-fav-a, .prod-detail-favBtn-a, .prod-detail-floatBtn .__favoBtn, .mod-prodPanel-favorite:not(".inFavBlock"), .prod-fav .mod-prodPanel-favorite.inFavBlock',
		function() {
		let $this = $(this);
		let prodCode;

		if ($this.hasClass('mod-prodPanel-favorite')) {
			prodCode = $this.parents('.mod-prodPanel').find('.rt_cf_p_code_8').attr('data-p_code_8');

			// 商品詳細
			if ($('.prod-detail').length) {
				let $sku = $('.rt_cf_p_code_8_sku').attr('data-p_code_8');
				if ($this.prev('.rt_cf_p_code_8').attr('data-p_code_8') === $sku) {
					$('.prod-detail-favBtn-a').removeClass(a);
					$('.prod-detail-floatBtn .__favoBtn').removeClass(a);
				}
			}
		} else if ($this.hasClass('prod-detail-favBtn-a') || $this.hasClass('__favoBtn')) {
			prodCode = $(this).attr('data-p_code_8');
		} else if ($this.hasClass('prod-modal-fav-a')) {
			prodCode = $this.parents('.prod-modal').find('.rt_cf_p_code_8').attr('data-p_code_8');
			$this.removeClass('is-hover01');
			$this.parents('.mod-prodPanel').find('.mod-prodPanel-favorite').addClass(a);
		}

		if (!$this.hasClass(a)) {
			let favoDatetime = new Date();
			favoDatetime = favoDatetime.toLocaleString();
			localStorage.setItem('favItem-' + prodCode, favoDatetime);
			$this.addClass(a);

			// 商品詳細は2箇所のボタンを連動させる
			if ($this.hasClass('prod-detail-favBtn-a')) {
				$('.prod-detail-floatBtn .__favoBtn').addClass(a);
			} else if ($this.hasClass('__favoBtn')) {
				$('.prod-detail-favBtn-a').addClass(a);
			}
		} else {
			localStorage.removeItem('favItem-' + prodCode);
			$this.removeClass(a);

			if ($this.hasClass('prod-detail-favBtn-a')) {
				$('.prod-detail-floatBtn .__favoBtn').removeClass(a);
			} else if ($this.hasClass('__favoBtn')) {
				$('.prod-detail-favBtn-a').removeClass(a);
			}
		}

		// お気に入り商品数をフロートナビに反映
		const $floatNav = $('.floatNav');
		let favoStorage = [];
		let favArr = [];
		for (let i in localStorage) {
			if (i.indexOf('favItem-') !== -1) {
				favoStorage.push(i);
			}
		}

		for (let i = 0; i < favoStorage.length; i++) {
			let hash = {
				name: favoStorage[i],
				datetime: localStorage[favoStorage[i]]
			};
			favArr.push(hash);
		}
		favArr.sort(
			function(x, y){
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if (xDate > yDate) return(1);
				if (xDate < yDate) return(-1);
				return 0;
			}
		);

		// お気に入り登録数は12まで
		if (favoStorage.length > 12) {
			alert('お気に入りリストに登録できる商品は最大12点です。');
			localStorage.removeItem(favArr[favArr.length - 1].name);
			favoStorage.pop();
			$this.removeClass(a);
			delete favArr[favArr.length -1];
			favArr.pop();
		}

		// フロートナビにお気に入り商品数を表示
		$floatNav.find('.icon-favorite').addClass(a);
		setTimeout(function(){
			$floatNav.find('.icon-favorite').removeClass(a);
		}, 170);
		$floatNav.find('.js-favocount').text(favoStorage.length);

		// 商品詳細ページの場合
		if ($('.prod-detail').length) {

			// 商品詳細のお気に入りリストブロックにお気に入り商品数を表示
			$('.prod-detail-favBlock .favNum').text(favoStorage.length);
			// お気に入りリスト描画
			$('.mod-favList').children('.mod-favList-wrap').remove();
			getFavoList();
		}

	});

	// ＜共通＞お気に入り商品かチェック
	const checkFavo = (_thisProdCode) => {
		for (let item in localStorage) {
			if (item.indexOf('favItem-') !== -1) {
				if (item.replace(/favItem-/, '') === _thisProdCode) {
					return true;
				}
			}
		}
		return false;
	};

	// ＜共通＞商品画像モーダル
	const prodPanelModal = () => {
		let $modal = $('.js-modal');
		let $modalContent = $('.js-modal-content');
		let m = 'is-modal';
		let scrollTopNow;
		let $modalItem;

		$(document).on('click', '.js-modal-btn, .colorSelect-btn .mod-button-a', (e) => {
			if ($(e.currentTarget).hasClass('js-modal-btn')) {
				// mod-prodPanelのモーダル
				$modalItem = $('.prod-modal');
				let thisProd = $(e.currentTarget).parents('.mod-prodPanel');
				thisProd.children('.prod-modal').addClass(m);
				if (thisProd.find('.mod-prodPanel-favorite.is-active').length !== 0) {
					thisProd.children('.prod-modal').find('.prod-modal-fav-a').removeClass('is-hover01').addClass(a);
				} else {
					thisProd.children('.prod-modal').find('.prod-modal-fav-a').addClass('is-hover01').removeClass(a);
				}
			} else {
				// 商品詳細のカラー（サイズ）選択リスト
				prodDetailSizeSelect();
				$modalItem = $('.colorSelect-panel').addClass(m);
			}

			$modal.addClass(a);
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});

			$('body').addClass(f);
			e.preventDefault();
		});

		$modalContent.on('click', (e) => {
			if (!$(e.target).closest('.mod-button, .mod-a, .colorSelect-panel').length) {
				$modal.removeClass(a);
				$modalItem.removeClass(m);
				$('.container').css({
					position: 'static',
				});
				$('body').removeClass(f);
				$(window).scrollTop(scrollTopNow);
				e.preventDefault();
			}
		});

		$(document).on('click', '.js-modal-overlay, .prod-modal .icon-close, .colorSelect-panel .icon-close', (e) => {
			$modal.removeClass(a);
			$modalItem.removeClass(m);
			$('.container').css({
				position: 'static',
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
			e.preventDefault();
		});
	};

	// ＜商品検索＞----------------------------------------------------
	// <商品検索>SP版サイドナビ
	const spSearchSideNav = () => {
		const sideNav = $('.mod-sideNav-nav');
		const floatBtn = $('.prod-search-floatBtn');

		// スクロールでフロートボタン表示
		let scrollStopEvent = new $.Event('scrollstop');
		let delay = 1500;
		let scrTop;
		let timer;

		function scrollStopEventTrigger() {
			if (timer) { clearTimeout(timer); }
			timer = setTimeout(() => { $(window).trigger(scrollStopEvent); }, delay);
		}
		$(window).on('scroll', scrollStopEventTrigger);
		$('body').on('touchmove', scrollStopEventTrigger);

		// スクロールしたら「条件を絞り込む」ボタン出現。
		$(window).scroll(() => {
			floatBtn.addClass(a);
		});
		// スクロール停止して少ししたら引っ込む。
		$(window).on('scrollstop', () => {
			floatBtn.removeClass(a);
		});

		// フォームOpen
		const openProdSearchForm = () => {
			sideNav.addClass(v).css('opacity', 0).animate({ opacity: 1 }, 100);
			scrTop = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrTop,
				left: 0
			});
			$('body').addClass(f);
			$(window).scrollTop(scrTop);
			e.preventDefault();
		};
		floatBtn.on('click', openProdSearchForm);
		$('.js-prodSearchFormOpen').on('click', openProdSearchForm);

		// フォームClose
		$('.prod-sideNav-close').on('click', (e) => {
			sideNav.animate({ opacity: 0 }, 100).delay(100).queue(function (next) {
				sideNav.removeClass(v);
				next();
			});
			scrTop = $('.container').css('top').replace(/-|px/g, '');
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrTop);
			e.preventDefault();
		});
	};
	// <商品検索> ブランド内カテゴリ取得
	const getBrandCategory = (_bland) => {
		const url = new URL(window.location.href);
		const params = url.searchParams;
		const categorySelect = $('select[name="p_brand_category"]');
		categorySelect.find('option.js-add').remove();

		// EDGEとSPシリーズのみ
		if (_bland === '097' || _bland === '081') {
			getJSONgetCategoryList(_bland).then((data) => {
				let categoryList = data.rt_bn_product;
				if (categoryList.length) {
					if (categoryList.length <= 1 && categoryList[0].cf_p_brand_category === '') {
						// 存在しない場合
						$('.js-brandCategory').addClass('di_none');
					} else {
						for (let i = 0; i < categoryList.length; i++) {
							let thisName = categoryList[i].cf_p_brand_category;
							if (thisName === params.get('p_brand_category')) {
								categorySelect.append('<option value="'+ thisName +'" selected="selected" class="js-add">'+ thisName +'</option>');
							} else {
								categorySelect.append('<option value="'+ thisName +'" class="js-add">'+ thisName +'</option>');
							}
						}
						$('.js-brandCategory').removeClass('di_none');
					}

				} else {
					$('.js-brandCategory').addClass('di_none');
				}
			});
		} else {
			$('.js-brandCategory').addClass('di_none');
		}
	};

	// ＜商品詳細ページ・お気に入りリスト共通＞--------------------------------
	// <商品詳細ページ・お気に入りリスト共通>サイズ選択パネル表示切替
	const sizeSelectToggle = () => {
		const sizeSelectBtn = $('.mod-favList-item-btn');
		const sizeSelect = $('.sizeSelect');

		sizeSelectBtn.on('click', function(){
			if ($(this).hasClass(a)) {
				sizeSelectBtn.removeClass(a);
				sizeSelect.removeClass(a);
				$(this).removeClass(a);
				$(this).next(sizeSelect).removeClass(a);
			} else {
				sizeSelectBtn.removeClass(a);
				sizeSelect.removeClass(a);
				$(this).addClass(a);
				$(this).next(sizeSelect).addClass(a);
			}
		});
	};

	// <商品詳細ページ・お気に入りリスト共通> サイズを1つ以上選択したら「選択する」ボタンを押下可能にする
	const sizeSelectfire = () => {
		let clearBtn = $('.icon-close'),
			reservationBtn = $('.reservationBtn'),
			favItem = $('.mod-favList-item'),
			bikouArr = [],
			nameArr = [],
			colorArr = [],
			sizeArr = [],
			priceArr = [];

		$('.mod-favList').on('change', '.sizeSelect .mod-check-input', function(){
			let checkedItem = $(this).parents('.sizeSelect').find('input:checkbox:checked');
			let checkedItemLen = checkedItem.length;
			let checkedItemAll = $(this).parents('.mod-favList').find('input:checkbox:checked').length;

			if (checkedItemLen !== 0) {
				$(this).parents('.sizeSelect').find('.mod-button-a').addClass('is-hover01');

				$('.sizeSelect-btn').find('.mod-button-a').on('click', function(){
					$(this).parents('.sizeSelect').prev('.mod-favList-item-btn').removeClass(a);
					$(this).parents('.sizeSelect').removeClass(a);
					$(this).parents('.mod-favList-item').addClass('selected');

					// 試着（来店）予約ボタンを押下可能にする
					reservationBtn.addClass('is-hover01');
				});

			} else {
				$(this).parents('.sizeSelect').find('.mod-button-a').removeClass('is-hover01');
			}

			// チェック数が6を超えたらアラートを出す
			if (checkedItemAll > 6) {
				$(this).prop('checked', false);
				alert('試着予約は合計で最大６本までお受けいたします。');
				if ($(this).parents('.sizeSelect').find('input:checkbox:checked').length === 0) {
					$(this).parents('.sizeSelect').find('.sizeSelect-btn .mod-button-a').removeClass('is-hover01');
				}
			}
		});

		// paramArrに追加
		$('.sizeSelect-btn .mod-button-a').on('click', function(){
			$(this).parents('.sizeSelect').find('.mod-check-input').each(function(){
				if ($(this).prop('checked') === true) {
					let checkedItemBikou = $(this).attr('data-p-bikou');
					let checkedItemName = $(this).attr('data-p-name');
					let checkedItemColor = $(this).attr('data-p-color');
					let checkedItemSize = $(this).attr('data-p-size');
					let checkedItemPrice = $(this).attr('data-p-price');
					bikouArr.push(checkedItemBikou);
					nameArr.push(checkedItemName);
					colorArr.push(checkedItemColor);
					sizeArr.push(checkedItemSize);
					priceArr.push(checkedItemPrice);
				}
			});

			// パラメータを引き継ぐ
			let param = 'bikou='+ bikouArr.join(',') +'&item_name=' + nameArr.join(',') +'&item_color='+ colorArr.join(',') +
			'&item_size='+ sizeArr.join(',') + '&item_price='+ priceArr.join(',');
			reservationBtn.attr('href', '/inquiry/trying_on/?' + param);
		});

		// ×アイコンをクリックしたらチェックボックスの選択を外す
		clearBtn.on('click', function(){
			$(this).parent(favItem).removeClass('selected');
			$(this).parent(favItem).find('.sizeSelect').find('.mod-check-input').prop('checked', false);
			$(this).parent(favItem).find('.sizeSelect-btn .mod-button-a').removeClass('is-hover01');

			// paramArrから削除
			$(this).parent(favItem).find('.sizeSelect').find('.mod-check-input').each(function(){

				let removeItemBikou = $(this).attr('data-p-bikou'),
					removeItemIndex = bikouArr.indexOf(removeItemBikou);

				if (removeItemIndex !== -1) {
					bikouArr.splice(removeItemIndex, 1);
					nameArr.splice(removeItemIndex, 1);
					colorArr.splice(removeItemIndex, 1);
					sizeArr.splice(removeItemIndex, 1);
					priceArr.splice(removeItemIndex, 1);
				}

			});

			// パラメータを引き継ぐ
			let param = 'bikou='+ bikouArr.join(',') +'&item_name=' + nameArr.join(',') +'&item_color='+ colorArr.join(',') +
			'&item_size='+ sizeArr.join(',') + '&item_price='+ priceArr.join(',');
			reservationBtn.attr('href', '/inquiry/trying_on/?' + param);

			// サイズが選択された商品がない場合、試着（来店）予約ボタンを押下不可にする
			if ($('.mod-favList-item.selected').length === 0) {
				reservationBtn.removeClass('is-hover01');
			}
		});
	};

	// <商品詳細ページ・お気に入りリスト共通>お気に入りのサイズと在庫を取得
	const getFavoItemSize = () => {
		$('.mod-favList-item').each(function(e){
			let thisCode = $(this).find('.rt_cf_p_code_8').attr('data-p_code_8');
			let $ul = $(this).find('.sizeSelect').find('ul');

			// サイズと在庫取得
			getJSONgetFavoList(`p_code_8=${thisCode}`).then((data) => {
				let sizeList = data.rt_bn_product_list;
				let sizeListLen = sizeList.length;
				let sizeAll;

				for (let k = 0; k < sizeListLen; k++) {
					let thisSize = {
						name: sizeList[k]['cf_p_model'],
						color: sizeList[k]['cf_p_color_name_2'],
						size: sizeList[k]['cf_p_size'],
						spacing: sizeList[k]['cf_p_size_spacing'],
						temple: sizeList[k]['cf_p_size_temple'],
						vertical: sizeList[k]['cf_p_size_vertical'],
						stock: sizeList[k]['cf_ps_center_number'],
						code8: sizeList[k]['cf_p_code_8'],
						price: sizeList[k]['cf_p_lens_included_price'],
						key: sizeList[k]['_key']
					};

					let stockText = '';
					if (thisSize.stock < 10) {
						stockText = '<span class="stock">残りわずか</span>';
					}

					if (sizeListLen > 1) {
						sizeAll = '<li><label class="mod-check" for="">' +
						'<input class="mod-check-input" type="checkbox" name="" id="" value="" data-p-bikou="'+
						thisSize.code8 +'x" data-p-name="' +
						encodeURI(thisSize.name) +'" data-p-color="'+ encodeURI(thisSize.color) +
						'" data-p-size="free" data-p-price="'+ thisSize.price +'"> '+
							'<span class="mod-check-text fs_14"><span>指定なし</span></span></label></li>';
					} else {
						sizeAll = '';
					}

					let sizeText = thisSize.size +'□'+ thisSize.spacing +'－'+ thisSize.temple +'　レンズ縦幅'+ thisSize.vertical +'mm';

					let sizeHTML = '<li><label class="mod-check" for="">' +
					'<input class="mod-check-input" type="checkbox" name="" id="" value="" data-p-bikou="'+
					thisSize.key +'" data-p-name="' +
					encodeURI(thisSize.name) +'" data-p-color="'+ encodeURI(thisSize.color) +'" data-p-size="' +
					encodeURI(sizeText) +'" data-p-price="'+ thisSize.price +'">' +
					'<span class="mod-check-text fs_14">' +
					stockText +
					'<span>' + sizeText +'</span></span></label></li>';
					$(sizeHTML).appendTo($ul);
				}
				$(sizeAll).appendTo($ul);
				if (e === $('.mod-favList-item').length - 1) {
					$('.mod-favList .mod-prodPanel').matchHeight();
				}
			});
		});
	};

	// <商品詳細ページ・お気に入りリスト共通>localStorageからお気に入りリスト取得&描画
	const getFavoList = () => {
		let favoStorage = [];
		let favArr = [];
		let itemParamArr = [];

		for (let i in localStorage) {
			if (i.indexOf('favItem-') !== -1) {
				favoStorage.push(i);
			}
		}
		for (let i = 0; i < favoStorage.length; i++) {
			let hash = {
				name: favoStorage[i],
				datetime: localStorage[favoStorage[i]]
			};
			favArr.push(hash);
		}

		// お気に入り登録日が新しい順にソート
		favArr.sort(
			function(x, y){
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if (xDate > yDate) return-1;
				if (xDate < yDate) return 1;
				return 0;
			}
		);

		// パラメータを作成
		for (let i = 0; i<favArr.length; i++) {
			itemParamArr.push('p_code_8=' + favArr[i].name.replace(/favItem-/, ''));
		}

		if (favoStorage.length > 0) {
			getJSONgetFavoList(`${itemParamArr.join('&')}`).then((data) => {
				let favHTML;
				let prodListItem = data.rt_bn_product_list;
				if (prodListItem.length !== 0) {
					for (let i=0; i<itemParamArr.length; i++) {
						let timeOrderItem = itemParamArr[i].replace(/p_code_8=/, '');
						for (let j=0; j<prodListItem.length; j++) {
							let thisData = {
								code7: prodListItem[j].cf_p_code_7,
								code8: prodListItem[j].cf_p_code_8,
								img: prodListItem[j].rt_p_img.src,
								name: prodListItem[j].cf_p_model,
								price: prodListItem[j].rt_cf_p_lens_price.content,
								href: prodListItem[j].rt_p_href.href,
								vertical: prodListItem[j].cf_p_size_vertical,
								stock: prodListItem[j].cf_ps_number,
								new: prodListItem[j].rt_p_new
							};
							if (thisData.code8 === timeOrderItem) {

								let thisProd = prodListItem.filter(function(item, index){
									if (item.cf_p_code_8 === thisData.code8) return true;
								});

								// 同商品(8桁のコード一致）一個目のデータを書き出す
								if (thisData.vertical === thisProd[0].cf_p_size_vertical && thisData.stock === thisProd[0].cf_ps_number) {
									let newHTML = '';
									if (thisData.new !== null) {
										newHTML = '<span class="mod-prodPanel-new">NEW</span>';
									}
									let modalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' +
										'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ thisData.code8 +'"></span>' +
										newHTML +
										'<a href="'+ thisData.href +'#'+ thisData.code8 +'" class="prod-modal-a rt_p_href">' +
										'<img src="'+ thisData.img +'" alt="'+ thisData.name +'" class="width-u-100 rt_p_img"></a>' +
										'<a href="'+ thisData.href +'#'+ thisData.code8 +'" class="prod-modal-a rt_p_href">' +
										'<p class="prod-modal-name rt_cf_p_model">'+ thisData.name +'</p>' +
										'<p class="prod-modal-price">レンズ付き '+ thisData.price +'</p></a>' +
										'<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' +
										'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' +
										'<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01">' +
										'<span class="mod-button-txt"></span>' +
										'<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' +
										'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' +
										'<a href="'+ thisData.href +'#'+ thisData.code8 +'" class="mod-button-a is-hover01 rt_p_href">' +
										'<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' +
										'</a></div></li></ul></div></div></div>';

									favHTML = '<li class="pure-u-1-4 pure-u-md-1-2 space-u-20-child mod-favList-wrap">' +
										'<div class="mod-favList-item"><i class="icon icon-close"></i>' +
										'<div class="mod-prodPanel">' +
										'<div class="mod-prodPanel-iconBlock">' +
										'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ thisData.code8 +'"></span>' +
										newHTML +
										'<span class="mod-prodPanel-favorite is-active inFavBlock"><i class="icon icon-favorite"></i></span>' +
										'<button class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></button>' +
										'</div>' +
										'<a href="'+ thisData.href +'#'+ thisData.code8 +'" class="mod-a rt_p_href">' +
										'<img src=" '+ thisData.img +'" alt="'+ thisData.name +'" class="width-u-100 rt_p_img"></a>' +
										'<div class="mod-prodPanel-text">' +
										'<a href="'+ thisData.href +'#'+ thisData.code8 +'" class="mod-a rt_p_href">' +
										'<p class="mod-prodPanel-text_name">'+ thisData.name +'</p>' +
										'<p class="mod-prodPanel-text_price">レンズ付き '+ thisData.price +'</p></a></div>'+ modalHTML +'</div>' +
										'<div class="mod-favList-item-btn">' +
										'<span class="mod-favList-item-txt">サイズを選ぶ'+
										'<i class="icon icon-arrow_bottom mod-iconArrowRight"></i>' +
										'</span><span class="mod-favList-item-txt_selected">選択済</span></div>' +
										'<div class="sizeSelect"><div class="sizeSelect-inner">' +
										'<img src="/images/products/img_triangle.png" alt="" class="triangle"><ul></ul>' +
										'<div class="sizeSelect-btn"><div class="mod-button"><span class="mod-button-a">' +
										'<span class="mod-button-txt">選択する</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' +
										'</span></div></div></div>'+
										'</div></div></li>';

									$('.mod-favList').append(favHTML);

								}
							}
						}
					}
					favIcon();
					getFavoItemSize();
					sizeSelectToggle();
					sizeSelectfire();
				}
			});
			$('.prod-fav-no_favItem').removeClass(v);
			$('.prod-favBlock-btnWrap').addClass(v);
		} else {
			$('.prod-fav-no_favItem').addClass(v);
			$('.prod-favBlock-btnWrap').removeClass(v);

		}
	};

	// ＜商品詳細ページ＞-------------------------------------------------
	// <商品詳細ページ>おすすめの商品描画
	const recommendProd = () => {
		let $sku = $('.rt_cf_p_code_8_sku').attr('data-p_code_8');
		// おすすめの商品描画
		let p_material = $('.prod-detail-recommendBlock .rt_bn_product_info .rt_cf_p_material').text().split('|'),
			p_lens_shap = $('.prod-detail-recommendBlock .rt_bn_product_info .rt_cf_p_lens_shape').text().split('|'),
			p_sex = $('.prod-detail-recommendBlock .rt_bn_product_info .rt_cf_p_sex').text().split('|'),
			recommendParam = [];

		for (let i = 0; i < p_material.length; i++) {
			recommendParam.push('p_material=' + encodeURI(p_material[i]));
		}
		for (let i = 0; i < p_lens_shap.length; i++) {
			recommendParam.push('p_lens_shape=' + encodeURI(p_lens_shap[i]));
		}
		for (let i = 0; i < p_sex.length; i++) {
			recommendParam.push('p_sex=' + encodeURI(p_sex[i]));
		}

		getJSONgetrecommendList(`${recommendParam.join('&')}`).then((data) => {
			let reccomendList = data.rt_bn_product_list;
			let reccomendListLen = reccomendList.length;

			for (let j = 0; j < reccomendListLen; j++) {
				let itemDetail = {
					name: reccomendList[j]['cf_p_model'],
					img: reccomendList[j]['rt_p_img'].src,
					price: reccomendList[j]['rt_cf_p_lens_price'].content,
					code7: reccomendList[j]['cf_p_code_7'],
					code8: reccomendList[j]['cf_p_code_8'],
					href: reccomendList[j]['rt_p_href'].href,
					new: reccomendList[j]['rt_p_new']
				};

				if (itemDetail.code8 !== $sku) {
					let newHTML = '';
					if (itemDetail.new !== null) {
						newHTML = '<span class="mod-prodPanel-new">NEW</span>';
					}

					let modalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' +
						'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ itemDetail.code8 +'"></span>' +
						newHTML +
						'<a href="'+ itemDetail.href +'" class="prod-modal-a">' +
						'<img src="'+ itemDetail.img +'" alt="'+ itemDetail.name +'" class="width-u-100"></a>' +
						'<a href="'+ itemDetail.href +'" class="prod-modal-a">' +
						'<p class="prod-modal-name">'+ itemDetail.name +'</p>' +
						'<p class="prod-modal-price">レンズ付き '+ itemDetail.price +'</p></a>' +
						'<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' +
						'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' +
						'<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01"><span class="mod-button-txt"></span>' +
						'<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' +
						'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' +
						'<a href="'+ itemDetail.href +'" class="mod-button-a is-hover01">' +
						'<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' +
						'</a></div></li></ul></div></div></div>';

					let prodHTML = '<li class="pure-u-1-4 pure-u-md-1-2 space-u-20-child"><div class="mod-prodPanel">' +
						'<div class="mod-prodPanel-iconBlock">' +
						'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ itemDetail.code8 +'"></span>' + newHTML +
						'<span class="mod-prodPanel-favorite"><i class="icon icon-favorite"></i></span>' +
						'<button class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></button></div>' +
						'<a href="'+ itemDetail.href +'" class="mod-a">' +
						'<img src="'+ itemDetail.img +'" alt="'+ itemDetail.name + '" class="width-u-100"></a><div class="mod-prodPanel-text">' +
						'<a href="'+ itemDetail.href +'" class="mod-a">' +
						'<p class="mod-prodPanel-text_name">'+ itemDetail.name +'</p>' +
						'<p class="mod-prodPanel-text_price">レンズ付き '+ itemDetail.price +'</p></a></div>' +
						modalHTML + '</div></div></li>';

					$(prodHTML).appendTo('.prod-detail-recommendBlock .recommendOutput');
				}
				if ($('.recommendOutput .mod-prodPanel').length === 4) {
					break;
				}
			}
		});
	};

	// <商品詳細ページ>試着予約へパラメータを引き継ぐ
	const prodDetailSizeSelect = () => {
		let reservationBtn2 =$('.colorSelect-panel-submit .mod-button-a');

		$('.colorSelect-panel').find('.mod-check-input').change(function(){
			let bikouArr2 = [],
				nameArr2 = [],
				colorArr2 = [],
				sizeArr2 = [],
				priceArr2 = [];
			let checkedItem = $('.colorSelect-panel .mod-tbl02').find('input:checkbox:checked');
			let checkedItemLen = checkedItem.length;
			// サイズを1つ以上選択したら「選択する」ボタンを押下可能にする
			if (checkedItemLen === 0) {
				reservationBtn2.removeClass('is-hover01');
			} else if (checkedItemLen > 6) {
				$(this).prop('checked', false);
				alert('試着予約は合計で最大６本までお受けいたします。');
			} else {
				reservationBtn2.addClass('is-hover01');
			}

			$('.colorSelect-panel').find('.mod-check-input').each(function(){
				if ($(this).prop('checked') === true) {
					let checkedItemBikou2 = $(this).attr('data-p-bikou'),
						checkedItemName2 = $(this).attr('data-p-name'),
						checkedItemColor2 = $(this).attr('data-p-color'),
						checkedItemSize2 = $(this).attr('data-p-size'),
						checkedItemPrice2 = $(this).attr('data-p-price');

					bikouArr2.push(checkedItemBikou2);
					nameArr2.push(checkedItemName2);
					colorArr2.push(checkedItemColor2);
					sizeArr2.push(checkedItemSize2);
					priceArr2.push(checkedItemPrice2);
				}
			});


			let param2 = 'bikou='+ bikouArr2.join(',') +'&item_name=' + nameArr2.join(',') +
				'&item_color='+ colorArr2.join(',') +
				'&item_size='+sizeArr2.join(',') + '&item_price=' + priceArr2.join(',');

			reservationBtn2.attr('href', '/inquiry/trying_on/?' + param2);
		});
	};

	// <商品詳細ページ>構造化データ出力
	const prodDetailLDJSON = () => {
		const domain = 'https://www.paris-miki.co.jp';
		let appendSrc =
			'{"@context": "http://schema.org/", "@type": "Product",' +
			`"name": "${$('.mod-head01-inner').text()}",` +
			`"image": ["${$('.prod-detail-mainImg').find('img').eq(0).attr('src')}",` +
			`"${$('.prod-detail-mainImg').find('img').eq(1).attr('src')}",` +
			`"${$('.prod-detail-mainImg').find('img').eq(2).attr('src')}"],` +
			`"description": "${$('.rt_cf_p_description').text()}",` +
			'"brand": {"@type": "Brand", "name": "パリミキ"},' +
			`"offers": {"@type": "Offer", "url": "${domain}${location.pathname}",` +
			`"priceCurrency": "JPY", "price": "${$('.rt_cf_p_lens_included_price').text().replace(/\,/, '')}"}}`;

		$('.jsonld-script').append(appendSrc);
	};

	// ＜お気に入りリストページ＞-------------------------------------------------
	if ($('.prod-fav').length) {
		getFavoList();
		prodPanelModal();
	}

	// ＜カテゴリーページ＞------------------------------------------------------
	if ($('.prod-cat').length) {
		// <カテゴリーページ> ブランドごとの商品を描画
		let $cat = $url.split('/')[$url.split('/').length - 1].replace(/\.html/, '');
		const brandBlock = $('.prod-cat-bland'),
			$select = $('.prod-cat-select select');
		let lastBrand = $('.prod-cat-bland:last').find('.rt_cf_pb_key').attr('data-cf_pb_key');

		// プルダウンメニュー
		$select.on('change', function(){
			let $href = $(this).val() + '.html';
			location.href = $href;
		});
		$select.val($cat);

		brandBlock.each(function(){
			let brandKey = $(this).find('.rt_cf_pb_key').attr('data-cf_pb_key'),
				output = $(this).find('.prod-brand-output'),
				output01 = output.children('.prod-brand-output-01'),
				output02 = output.children('.prod-brand-output-02').children('.pure-g');

			getJSONgetBrandProd(`${brandKey}`).then((data) => {
				let prodList = data.rt_bn_product_list;
				let prodListLen = prodList.length;

				let newHTML = '';

				let firstItemDetail = {
					name: prodList[0]['cf_p_model'],
					img: prodList[0]['rt_p_img'].src,
					price: prodList[0]['rt_cf_p_lens_price'].content,
					code7: prodList[0]['cf_p_code_7'],
					code8: prodList[0]['cf_p_code_8'],
					href: prodList[0]['rt_p_href'].href,
					new: prodList[0]['rt_p_new']
				};

				if (firstItemDetail.new !== null) {
					newHTML = '<span class="mod-prodPanel-new">NEW</span>';
				}

				let firstModalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' +
						'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ firstItemDetail.code8 +'"></span>' +
						newHTML +
						'<a href="'+ firstItemDetail.href +'" class="prod-modal-a rt_p_href">' +
						'<img src="'+ firstItemDetail.img +'" alt="'+ firstItemDetail.name +'" class="width-u-100 rt_p_img"></a>' +
						'<a href="'+ firstItemDetail.href +'" class="prod-modal-a rt_p_href">' +
						'<p class="prod-modal-name rt_cf_p_model">'+ firstItemDetail.name +'</p>' +
						'<p class="prod-modal-price">'+ firstItemDetail.price +'</p></a>' +
						'<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' +
						'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' +
						'<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01">' +
						'<span class="mod-button-txt"></span>' +
						'<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' +
						'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' +
						'<a href="'+ firstItemDetail.href +'" class="mod-button-a is-hover01 rt_p_href">' +
						'<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' +
						'</a></div></li></ul></div></div></div>';

				let firstProdHTML = '<div class="mod-prodPanel mod-prodPanel_large">' +
					'<div class="mod-prodPanel-iconBlock">' +
					'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ firstItemDetail.code8 +'"></span>' +
					newHTML +
					'<span class="mod-prodPanel-favorite"><i class="icon icon-favorite"></i></span>' +
					'<a href="" class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></a></div>' +
					'<a href="'+ firstItemDetail.href +'" class="mod-a rt_p_href">' +
					'<img src="'+ firstItemDetail.img +'" alt="" class="width-u-100 rt_p_img"></a>' +
					'<div class="mod-prodPanel-text"><div class="mod-prodPanel-text-inner">' +
					'<a href="'+ firstItemDetail.href +'" class="mod-a rt_p_href">' +
					'<p class="mod-prodPanel-text_name">'+ firstItemDetail.name +'</p>' +
					'<p class="mod-prodPanel-text_price">'+ firstItemDetail.price +'</p></a></div></div>'+
					firstModalHTML +'</div>';
				$(firstProdHTML).appendTo(output01);

				for (let j = 1; j < prodListLen; j++) {
					let itemDetail = {
						name: prodList[j]['cf_p_model'],
						img: prodList[j]['rt_p_img'].src,
						price: prodList[j]['rt_cf_p_lens_price'].content,
						code7: prodList[j]['cf_p_code_7'],
						code8: prodList[j]['cf_p_code_8'],
						href: prodList[j]['rt_p_href'].href,
						new: prodList[j]['rt_p_new']
					};

					if (itemDetail.new !== null) {
						newHTML = '<span class="mod-prodPanel-new">NEW</span>';
					} else {
						newHTML = '';
					}

					let modalHTML = '<div class="prod-modal"><div class="prod-modal-inner"><i class="icon icon-close"></i>' +
						'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ itemDetail.code8 +'"></span>' +
						newHTML +
						'<a href="'+ itemDetail.href +'" class="prod-modal-a rt_p_href">' +
						'<img src="'+ itemDetail.img +'" alt="'+ itemDetail.name +'" class="width-u-100 rt_p_img"></a>' +
						'<a href="'+ itemDetail.href +'" class="prod-modal-a rt_p_href">' +
						'<p class="prod-modal-name rt_cf_p_model">'+ itemDetail.name +'</p>' +
						'<p class="prod-modal-price">'+ itemDetail.price +'</p></a>' +
						'<div class="prod-modal-btnWrap"><ul class="pure-g space-u-20">' +
						'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child">' +
						'<div class="mod-button prod-modal-fav"><span class="mod-button-a prod-modal-fav-a is-hover01">' +
						'<span class="mod-button-txt"></span>' +
						'<i class="icon icon-favorite mod-iconArrowRight"></i></span></div></li>' +
						'<li class="pure-u-1-2 pure-u-md-1-1 space-u-20-child"><div class="mod-button">' +
						'<a href="'+ itemDetail.href +'" class="mod-button-a is-hover01 rt_p_href">' +
						'<span class="mod-button-txt">商品詳細</span><i class="icon icon-arrow_right mod-iconArrowRight"></i>' +
						'</a></div></li></ul></div></div></div>';

					let prodHTML = '<li class="pure-u-1-2 space-u-20-child"><div class="mod-prodPanel">' +
					'<div class="mod-prodPanel-iconBlock">' +
					'<span class="di_none rt_cf_p_code_8" data-p_code_8="'+ itemDetail.code8 +'"></span>' +
					newHTML +
					'<span class="mod-prodPanel-favorite"><i class="icon icon-favorite"></i></span>' +
					'<a href="" class="mod-prodPanel-modal js-modal-btn"><i class="icon icon-search"></i></a></div>' +
					'<a href="'+ itemDetail.href +'" class="mod-a rt_p_href">' +
					'<img src="'+ itemDetail.img +'" alt="" class="width-u-100 rt_p_img"></a><div class="mod-prodPanel-text">' +
					'<a href="'+ itemDetail.href +'" class="mod-a rt_p_href">' +
					'<p class="mod-prodPanel-text_name">'+ itemDetail.name +'</p>' +
					'<p class="mod-prodPanel-text_price">'+ itemDetail.price +'</p></a>' +
					'</div>'+ modalHTML +'</div></li>';

					$(prodHTML).appendTo(output02);

					if (brandKey === lastBrand) {
						if (j === prodListLen -1) {
							prodPanelModal();
							favIcon();

							$('.mod-prodPanel:not(.mod-prodPanel_large)').matchHeight();
						}
					}
				}
			});
		});
	}

	// <共通>各商品トップ メインスライダー----------------------------------------------
	if ($('.prod-idx').length) {
		let arrowPrev = '<button type="button" class="slick-prev"><i class="icon icon-arrow_left"></button>';
		let arrowNext = '<button type="button" class="slick-next"><i class="icon icon-arrow_right"></button>';

		$('.prod-idx-slider').slick({
			infinite: true,
			speed: 1000,
			autoplaySpeed: 4000,
			autoplay: true,
			slidesToShow: 1,
			arrows: true,
			prevArrow: arrowPrev,
			nextArrow: arrowNext,
			dots: true,
			centerMode: true,
			centerPadding: '140px',
			appendDots: $('.prod-idx-slider'),
			customPaging: function(){
				return'';
			},
			responsive: [
				{
					breakpoint: 767,
					settings: {
						centerMode: false
					}
				}
			]
		});
		favIcon();
		prodPanelModal();
	}


	// <商品一覧（検索結果一覧）>-------------------------------------------------
	if ($('.prod-search').length) {
		const brandSelect = $('select[name="p_brand_code"]');

		// 検索条件のブランドを描画
		getJSONgetBrandList().then((data) => {
			let brandList = data.rt_bn_brand;
			let brandListLen = brandList.length;

			for (let j = 0; j < brandListLen; j++) {
				let itemDetail = {
					name: brandList[j]['cf_pb_name'],
					key: brandList[j]['_key']
				};

				let brandHTML = '<option value="'+ itemDetail.key +'">'+ itemDetail.name +'</option>';
				$(brandHTML).appendTo(brandSelect);
			}

			// ブランドの選択状態を保つ
			let arg  = {};
			let url = location.search.substring(1).split('&');
			for (let i=0; url[i]; i++) {
				let k = url[i].split('=');
				arg[k[0]] = k[1];
			}
			let brandCode = arg.p_brand_code;
			brandSelect.children('option').each(function(){
				if ($(this).val() === brandCode) {
					$(this).attr('selected', 'selected');
				}
			});

			if (MIKI.va.window.width < 1024) {
				spSearchSideNav();
			}

			// ブランドの選択項目がある場合
			if (brandSelect.find('option[selected="selected"]').length) {
				// 選択項目がある場合
				let thisSelected = brandSelect.find('option[selected="selected"]').val();

				getBrandCategory(thisSelected);
			};
			// ブランド選択・変更時
			brandSelect.on('change', (e) => {
				let thisVal = $(e.currentTarget).val();

				getBrandCategory(thisVal);
			});
		});

		// ＜商品検索＞クリアボタン
		$('.prod-sideNav-clearBtn .mod-button-a').on('click', function(){
			$('.mod-check-input').each(function(){
				$(this).prop('checked', false);
			});
			$('.mod-select select').each(function(){
				$(this).val('');
			});
		});

		favIcon();

		prodPanelModal();
	}

	// 商品詳細------------------------------------------------------------------
	if ($('.prod-detail').length) {
		// 構造化データ出力
		prodDetailLDJSON();

		prodPanelModal();

		// おすすめ商品を描画
		recommendProd();

		// 商品画像スライダー
		let prodArrowPrev = '<i class="icon icon-arrow_left slick-prev"></i>';
		let prodArrowNext = '<i class="icon icon-arrow_right slick-next"></i>';
		var arr = Array.apply(null, new Array($('.prod-detail-slider li').length)).map(String.prototype.valueOf, 'camera');
		arr.splice(0, 1, 'glass_side');
		arr.splice(1, 1, 'product');

		$('.prod-detail-slider').slick({
			infinite: true,
			speed: 1000,
			autoplaySpeed: 4000,
			slidesToShow: 1,
			arrows: true,
			prevArrow: prodArrowPrev,
			nextArrow: prodArrowNext,
			dots: true,
			customPaging: function(slick, index){
				return'<i class="icon icon-' + arr[index] + '"></i>';
			}
		});

		// 「フレーム素材」「形（レンズシェイプ）」「特徴」の「|」を「、」に置換
		let material = $('.prod-detail-spec .rt_cf_p_material'),
			shape = $('.prod-detail-spec .rt_cf_p_lens_shape'),
			characteristic = $('.prod-detail-spec .rt_cf_p_characteristic');
		let materialText = material.text().replace(/\|/g, '、'),
			shapeText = shape.text().replace(/\|/g, '、'),
			characteristicText = characteristic.text().replace(/\|/g, '、');

		material.text(materialText);
		shape.text(shapeText);
		characteristic.text(characteristicText);

		// 商品画像スライダーの切り替え（表示色の変更）
		let slider = $('ul.prod-detail-slider'),
			$favBtn = $('.prod-detail-favBtn-a'), $favBtnFloat = $('.prod-detail-floatBtn .__favoBtn'),
			colorItem = $('.rt_cf_p_code_8_href'),
			$hash = location.hash.replace('#', ''),
			$sku = $('.rt_cf_p_code_8_sku').attr('data-p_code_8');

		// カラー選択
		$('.rt_cf_p_code_8_href').each(function(){
			let thisColorCode = $(this).attr('data-p_code_8');
			$(this).attr('href', $url + '#' + thisColorCode);
			if (thisColorCode === $hash) {
				$(this).parent('.colorList-item').addClass(a);
			}

			// newの出し分け
			let newFlag = $(this).attr('data-p_new');
			if (newFlag === '1') {
				$('li.rt_cf_p_code_8[data-p_code_8="'+ thisColorCode +'"]').parents('ul.prod-detail-slider')
					.append('<span class="prod-detail-mainImg-new">NEW</span>');
			}

			// soldout出し分け (商品スライド＆色アンカーリンク)
			getJSONgetColorDetail(`${thisColorCode}`).then((data) => {
				if (data.rt_bn_product_list.length === 0) {
					$(this).addClass('is-soldout');
					$(this).prepend('<i class="icon icon-close"></i>');
					// スライドに「SOLDOUT」表示
					$('li.rt_cf_p_code_8[data-p_code_8="'+ thisColorCode +'"]').parents('ul.prod-detail-slider')
						.append('<span class="prod-detail-mainImg-soldout">SOLDOUT</span>');
				} else {
					$(this).prepend('<i class="icon icon-circle"></i>');
				}
			});
		});

		let hashLen = String($hash).length; // ハッシュの桁数チェック
		slider.addClass('di_none'); // デフォルトでスライド非表示

		if (hashLen !== 8) { // ハッシュ無し場合orハッシュが不正の場合
			// 代表skuを表示
			$('li.rt_cf_p_code_8[data-p_code_8="'+ $sku +'"]').parents('ul.prod-detail-slider').removeClass('di_none');
			$('a.rt_cf_p_code_8_href[data-p_code_8="'+ $sku +'"]').parent('.colorList-item').addClass(a);

			// 「お気に入りに追加」ボタンのdata-p_code_8に代表skuのコードを充てる
			$favBtn.attr('data-p_code_8', $sku);
			// 代表skuがお気に入り登録済みの場合、「お気に入りに追加」ボタンを「お気に入り済」に設定
			if (checkFavo($sku)) {
				$favBtn.addClass(a);
				$favBtnFloat.addClass(a);
			}

			// $skuがsoldoutか判断
			getJSONgetColorDetail(`${$sku}`).then((data) => {
				if (data.rt_bn_product_list.length === 0) {
					$favBtn.addClass('is-soldout');
					$favBtnFloat.addClass('is-soldout');
				}
			});

		} else { // ハッシュ有りの場合
			$('li.rt_cf_p_code_8[data-p_code_8="'+ $hash +'"]').parents('ul.prod-detail-slider').removeClass('di_none');

			// 「お気に入りに追加」ボタンのdata-p_code_8に$hashを充てる
			$favBtn.attr('data-p_code_8', $hash);
			$favBtnFloat.attr('data-p_code_8', $hash);

			// $hashが気に入り登録済みの場合、「お気に入りに追加」ボタンを「お気に入り済」に設定
			if (checkFavo($hash)) {
				$favBtn.addClass(a);
				$favBtnFloat.addClass(a);
			}

			// $hashがsoldoutか判断
			getJSONgetColorDetail(`${$hash}`).then((data) => {
				if (data.rt_bn_product_list.length === 0) {
					$favBtn.addClass('is-soldout');
					$favBtnFloat.addClass('is-soldout');
				}
			});
		}

		colorItem.on('click', function(){
			slider.addClass('di_none');
			let thisColorCode = $(this).attr('data-p_code_8');
			$('.colorList-item').removeClass(a);
			$(this).parent('.colorList-item').addClass(a);
			$('li.rt_cf_p_code_8[data-p_code_8="'+ thisColorCode +'"]').parents('ul.prod-detail-slider').removeClass('di_none');

			// 「お気に入りに追加」ボタンに当てる8桁のコードを入れ替える
			$favBtn.attr('data-p_code_8', thisColorCode);
			$favBtnFloat.attr('data-p_code_8', thisColorCode);

			// クリックしたカラーがお気に入り登録済みの場合、「お気に入りに追加」ボタン「お気に入り済み」に設定
			let flgFavo = checkFavo(thisColorCode);
			if (flgFavo) {
				$favBtn.addClass(a);
				$favBtnFloat.addClass(a);
			} else {
				$favBtn.removeClass(a);
				$favBtnFloat.removeClass(a);
			}

			// クリックしたカラーがsoldoutの場合、「お気に入り追加」不可
			if ($(this).hasClass('is-soldout')) {
				$favBtn.addClass('is-soldout');
				$favBtnFloat.addClass('is-soldout');
			} else {
				$favBtn.removeClass('is-soldout');
				$favBtnFloat.removeClass('is-soldout');
			}

			// slick再設置
			$('.prod-detail-slider').slick('setPosition');
		});


		// 商品スライド下の予約ボタンをクリックした際に全色のサイズを表示
		let $thisCode7 = $url.split('/')[$url.split('/').length -1].replace(/\.html/, '');

		// サイズと在庫取得
		getJSONgetAllColorSize($thisCode7).then((data) => {
			let sizeList = data.rt_bn_product_list;
			let sizeListLen = sizeList.length;
			let sizeAll;

			for (let k = 0; k < sizeListLen; k++) {
				let thisSize = {
					name: sizeList[k]['cf_p_model'],
					color: sizeList[k]['cf_p_color_name_2'],
					size: sizeList[k]['cf_p_size'],
					spacing: sizeList[k]['cf_p_size_spacing'],
					temple: sizeList[k]['cf_p_size_temple'],
					vertical: sizeList[k]['cf_p_size_vertical'],
					stock: sizeList[k]['cf_ps_center_number'],
					code8: sizeList[k]['cf_p_code_8'],
					price: sizeList[k]['cf_p_lens_included_price'],
					key: sizeList[k]['_key']
				};

				// サイズが複数ある場合、一番下に「指定なし」を追加
				let color = sizeList.filter(function(item, index){
					if (item.cf_p_color_name_2 === thisSize.color) return true;
				});
				let colorLen = color.length -1;
				let lastKey = color[colorLen]._key;

				// 流通センター在庫数が10より少ない場合「残りわずか」と表示
				let stockText = '';
				if (thisSize.stock < 10) {
					stockText = '<span class="stock">残りわずか</span>';
				}

				if (colorLen !== 0) {
					if (thisSize.key === lastKey) {
						sizeAll = '<tr><td class="" colspan="3"><label class="mod-check" for="">' +
							'<input class="mod-check-input" type="checkbox" name="" id="" value="" data-p-bikou="'+
							thisSize.code8 +'x" data-p-name="' +
							encodeURI(thisSize.name) +'" data-p-color="'+ encodeURI(thisSize.color) +
							'" data-p-size="free" data-p-price="'+ thisSize.price +'">' +
							'<span class="mod-check-text"><div class="td-color">'+ stockText +
							'<span class="">'+ thisSize.color +'</span>' +
							'</div><div class="td-size"><span class="">指定なし</span>' +
							'</div></span></label></td></tr>';
					} else {
						sizeAll = '';
					}
				} else {
					sizeAll = '';
				}

				let sizeData = thisSize.size +'□'+ thisSize.spacing +'－'+ thisSize.temple +'レンズ縦幅'+ thisSize.vertical +'mm';
				let sizeText = thisSize.size +'□'+ thisSize.spacing +'－'+ thisSize.temple + '<br>' +
				'レンズ縦幅'+ thisSize.vertical +'mm';

				let sizeHTML = '<tr><td class="" colspan="3"><label class="mod-check" for="">' +
					'<input class="mod-check-input" type="checkbox" name="" id="" value="" data-p-bikou="'+
					thisSize.key +'" data-p-name="' +
					encodeURI(thisSize.name) +'" data-p-color="'+ encodeURI(thisSize.color) +'" data-p-size="' +
					encodeURI(sizeData) +'" data-p-price="'+ thisSize.price +'">' +
					'<span class="mod-check-text"><div class="td-color">' +
					stockText +
					'<span class="">'+ thisSize.color +'</span></div>' +
					'<div class="td-size">' +
					'<span class="">'+ sizeText +'</span>' +
					'</div></span></label></td></tr>' + sizeAll;
				$(sizeHTML).appendTo('.colorSelect-panel .mod-tbl02 tbody');
			}
		});

		// お気に入りリストを描画
		getFavoList();
		$('.js-toggle').on('click', function(){
			if (!$(this).hasClass(a)) {
				setTimeout(function(){
					$('.mod-favList .mod-prodPanel').matchHeight();
				}, 100);
			}
		});
	}

	// <商品詳細ページ>お気に入りリスト内の商品お気に入り削除時
	$('.prod-detail').on('click', '.mod-favList-wrap .mod-prodPanel-favorite', function(){
		let $this = $(this);
		let prodCode = $this.parents('.mod-prodPanel').find('.rt_cf_p_code_8').attr('data-p_code_8');
		let $sku = $('.rt_cf_p_code_8_sku').attr('data-p_code_8');

		localStorage.removeItem('favItem-' + prodCode);
		$this.removeClass(a);

		if ($this.prev('.rt_cf_p_code_8').attr('data-p_code_8') === $sku) {
			$('.prod-detail-favBtn-a').removeClass(a);
		}

		// お気に入り商品数をフロートナビに反映
		const $floatNav = $('.floatNav');
		let favoStorage = [];
		let favArr = [];
		for (let i in localStorage) {
			if (i.indexOf('favItem-') !== -1) {
				favoStorage.push(i);
			}
		}

		for (let i = 0; i < favoStorage.length; i++) {
			let hash = {
				name: favoStorage[i],
				datetime: localStorage[favoStorage[i]]
			};
			favArr.push(hash);
		}
		favArr.sort(
			function(x, y){
				let xDate = x['datetime'];
				let yDate = y['datetime'];
				if (xDate > yDate) return(1);
				if (xDate < yDate) return(-1);
				return 0;
			}
		);

		// お気に入り登録数は12まで
		if (favoStorage.length > 12) {
			localStorage.removeItem(favArr[0].name);
			favoStorage.pop();
		}

		// フロートナビにお気に入り商品数を表示
		$floatNav.find('.icon-favorite').addClass(a);
		setTimeout(function(){
			$floatNav.find('.icon-favorite').removeClass(a);
		}, 170);
		$floatNav.find('.js-favocount').text(favoStorage.length);

		// 商品詳細のお気に入りリストブロックにお気に入り商品数を表示
		$('.prod-detail-favBlock .favNum').text(favoStorage.length);

		// お気に入りリストを再描画
		$('.mod-favList').children('.mod-favList-wrap').remove();
		getFavoList();
		favIcon();
	});


})(window.jQuery, window.MIKI);
